// extracted by mini-css-extract-plugin
module.exports = {"listItem":"todo_listItem__3AKZf","checkbox":"todo_checkbox__1_niR","label":"todo_label__Ao5Jq","isDone":"todo_isDone__1HRwZ"};